/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reports_Col_RateInputs */

const cs_reports_col_rate = /** @type {(inputs: Reports_Col_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konverze`)
};

const en_reports_col_rate = /** @type {(inputs: Reports_Col_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversion`)
};

/**
* | output |
* | --- |
* | "Conversion" |
*
* @param {Reports_Col_RateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const reports_col_rate = /** @type {((inputs?: Reports_Col_RateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reports_Col_RateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reports_col_rate(inputs)
	return cs_reports_col_rate(inputs)
});